/** "Colocar no ar?" com a conta feita: verba × dias, contra o teto. */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { moeda } from "@/lib/meta-ads-format";
import { estimativaGasto } from "@shared/meta-ads-boost";

export function ConfirmarAtivacaoDialog({
  open,
  onOpenChange,
  dailyCents,
  currency,
  capCents,
  inicio,
  fim,
  onConfirm,
  isPending,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  dailyCents: number;
  currency: string | null;
  capCents: number | null;
  inicio: Date;
  fim: Date | null;
  onConfirm: () => void;
  isPending: boolean;
}) {
  const est = estimativaGasto(dailyCents, inicio, fim);
  const pct = capCents ? Math.min(100, Math.round((dailyCents / capCents) * 100)) : null;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Colocar no ar agora?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <p>
                <strong>{moeda(dailyCents, currency)} por dia</strong>
                {est.totalCents != null ? ` × ${est.dias} dia(s) = até ${moeda(est.totalCents, currency)}` : " — sem data de término: cobra todo dia até você pausar."}
              </p>
              {pct != null && (
                <div>
                  <div className="h-2 w-full rounded bg-muted">
                    <div className={`h-2 rounded ${pct >= 90 ? "bg-red-500" : "bg-primary"}`} style={{ width: `${pct}%` }} />
                  </div>
                  <p className="mt-1 text-xs text-muted-foreground">{pct}% do limite diário do workspace ({moeda(capCents, currency)})</p>
                </div>
              )}
              <p className="text-xs text-muted-foreground">Você pode pausar a qualquer momento em Anúncios.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Deixar pausado</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onConfirm(); }} disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Ativar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
